<template>
  <router-view :key="$route.fullPath"></router-view>
  <Card class="card">
    <template #title>
      Mitigation
      <div style="display: flex; justify-content: center">
        <p class="p-component" style="margin-top: 10px; margin-bottom: -10px">
          For each row, select a Quieter Construction Method using the dropdown. Click Calculate & Save once finished.
        </p>
        <Button icon="pi pi-times" aria-label="Close" class="p-button-rounded p-button-secondary p-button-text"
          style="position: fixed; right: 10px" @click="close()" />
      </div>
    </template>
    <template #content>
      <TabView v-model:activeIndex="tabActiveIndex" lazy>
        <TabPanel header="By Maximum Calculated noise">
          <ScrollPanel class="scrollContentPanel">
            <div class="formgrid grid">
              <div class="field col-12 md:col-2 fieldLabel" style="display: flex">
                <label>View highest noise level NSR: </label>
                <Dropdown v-model="selectedRank" :options="nsrRankOption" :onChange="rankChange" option-label="nsrname"
                  placeholder="Select a NSR" style="height: 30px; flex-grow: 1">
                </Dropdown>
              </div>
              <div class="field col-12 md:col-6"></div>
              <div class="field col-12 md:col-2">
                <label v-if="getCredit && getCurrentTotalUnmitigatedCnl - selectedRank.cnl >= 3"
                  style="color: #00632c"><i class="pi pi-check"></i>BEAM Plus credit</label>
              </div>
              <div class="field col-12 md:col-2">
                <label v-if="getCurrentNoiseResultText === 'Exceed buliding noise criteria'" style="color: red">{{
                  getCurrentNoiseResultText
                }}</label>
                <label v-else style="color: green">{{ getCurrentNoiseResultText }}</label>
              </div>

              <!-- <div class="field col-12 md:col-3">
                                <label>Start date: {{ formatDate(getCurrentStartDate) }}</label>
                            </div>
                            <div class="field col-12 md:col-3">
                                <label>End date: {{ formatDate(getCurrentEndDate) }}</label>
                            </div> -->
              <!-- <div class="field col-12 md:col-2">
                                <label>NSR Name: {{ selectedRank.nsrname }}</label>
                            </div> -->
              <div class="field col-12 md:col-6">
                <label>Building Name: {{ selectedRank.buildingName }}</label>
              </div>
              <div class="field col-12 md:col-2">
                <label>Total Unmitigated CNL: {{ getCurrentTotalUnmitigatedCnl.toFixed(1) }}</label>
              </div>
              <div class="field col-12 md:col-2">
                <label>Total Mitigated CNL: {{ selectedRank.cnl ? selectedRank.cnl.toFixed(1) : 0 }}</label>
              </div>
              <div class="field col-12 md:col-2">
                <label>Noise criteria: {{ selectedRank.noisecriteria }}</label>
              </div>

              <DataTable :value="updatedMitigatedEquipments" class="p-datatable-sm" id="equipmentInput"
                :scrollable="true" scroll-direction="vertical"
                :scroll-height="lastRedFloor > -1 ? 'calc(48vh - 50px)' : 'calc(57vh - 50px)'" :paginator="true"
                :rows="50"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageDropdown"
                responsiveLayout="scroll" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                style="width: 100%">
                <!-- <Column field="groupTask" header="Group - Task" ></Column> -->
                <Column field="groupTask" header="Tasks" :sortable="true" frozen style="min-width: 10%"> </Column>
                <Column field="exclusiveGroup" header="Group" :sortable="true" frozen style="min-width: 8%"> </Column>
                <Column field="pme" header="Equipment" :sortable="true" frozen style="min-width: 20%">
                  <template #body="slotProps">
                    <label v-if="slotProps.data.isQCM && getStage != 1">{{ slotProps.data.qpmename }}</label>
                    <label v-else>{{ slotProps.data.pme }}</label>
                  </template>
                </Column>

                <Column field="noisePower" header="Sound Power Level" :sortable="true" style="min-width: 4%">
                  <template #body="slotProps">
                    <label v-if="slotProps.data.isQCM && getStage != 1">{{ slotProps.data.qpmeNoisePower }}</label>
                    <label v-else>{{ slotProps.data.noisePower }}</label>
                  </template>
                </Column>
                <Column field="quantity" header="Qty" :sortable="true" style="min-width: 3%; max-width: 3%"> </Column>
                <Column field="timePercent" header="%" :sortable="true" style="min-width: 3%; max-width: 3%"> </Column>
                <Column field="contribution" header="Contribution" :sortable="true" style="min-width: 6%">
                  <template #body="slotProps">
                    <label>{{ slotProps.data.contribution.toFixed(1) }}</label>
                  </template>
                </Column>
                <!-- <Column field="timePercentCorrection" header="% correction" style="width:4%;max-width:4%;">
                                    <template #body="slotProps">
                                        <label>{{ slotProps.data.timePercentCorrection.toFixed(1) }}</label>
                                    </template>
                                </Column> -->
                <Column field="qpmename" header="Quieter Construction Method" :sortable="true" style="min-width: 13%"
                  v-if="getStage === 1">
                  <template #body="slotProps">
                    <div class="formgrid grid" style="width: 100%; min-width: 210px">
                      <CascadeSelect class="field col-12 md:col-10" v-model="slotProps.data.qpmename" :options="qcmList"
                        optionLabel="name" :optionGroupChildren="['equipments']" optionGroupLabel="name"
                        :placeholder="getIsCustomMethod(slotProps.data.qpmename) ? 'Custom' : 'Select a Method'"
                        optionValue="name" style="margin: 5px 0; height: 30px; max-width: 400px"
                        @change="updateQCMNoisePower(slotProps.data)" v-if="getIsReadOnly === false && getStage === 1">
                      </CascadeSelect>
                      <Button class="field col-12 md:col-1" icon="pi pi-minus" v-tooltip="'Remove'"
                        style="margin: 5px 0 5px 5px; height: 30px; width: 30px" aria-label="Remove Method" @click="
                          slotProps.data.qpmename = '';
                        slotProps.data.isQCM = false;
                        slotProps.data.qpmeNoisePower = 0;
                        " :disabled="!slotProps.data.isQCM"></Button>
                      <InputText class="field col-12" style="height: 30px" aria-label="Custom Method" v-if="
                        getIsReadOnly === false &&
                        getStage === 1 &&
                        (slotProps.data.qpmename == 'Custom' || (getIsCustomMethod(slotProps.data.qpmename) && slotProps.data.isQCM))
                      " v-model="slotProps.data.customQCMName" @blur="updateCustomQCMNoisePower(slotProps.data)"
                        placeholder="Custom Method">
                      </InputText>
                      <label v-else-if="slotProps.data.isQCM && (getIsReadOnly || getStage != 1)">{{
                        slotProps.data.qpmename }}</label>
                    </div>
                  </template>
                </Column>
                <Column field="qpmename" header="QPME" :sortable="true" style="min-width: 12%" v-if="getStage > 1">
                  <template #body="slotProps">
                    <!-- <InputText v-model="slotProps.data.qpmename"   /> 
                                        <label v-if="slotProps.data.qpmeList.length <= 0">N/A</label>-->
                    <label v-if="slotProps.data.isQCM">Quieter Construction Method Applied</label>
                    <div v-else-if="getIsReadOnly === false && getStage === 2"
                      v-tooltip.top="'Select a QPME or Enter Customized Quiet Equipment Name'">
                      <Dropdown v-model="slotProps.data.qpmename" :options="slotProps.data.qpmeList"
                        placeholder="Select a QPME" @change="updateQPMENoisePower(slotProps.data)" editable="true">
                      </Dropdown>
                      <label v-if="slotProps.data.qpmename.startsWith('QPME')">Please include model number</label>
                    </div>
                    <label v-else-if="getIsReadOnly || getStage === 3">{{ slotProps.data.qpmename }}</label>
                  </template>
                </Column>
                <Column field="qpmeNoisePower" header="Sound Power Level" :sortable="true" style="min-width: 5%">
                  <template #body="slotProps">
                    <!-- <label v-if="slotProps.data.qpmeList.length <= 0">N/A</label> -->
                    <div class="formgrid grid" style="width: 100%" v-if="
                      (getIsReadOnly === false && getStage === 2 && !slotProps.data.isQCM) ||
                      (getStage === 1 && getIsCustomMethod(slotProps.data.qpmename) && slotProps.data.isQCM)
                    ">
                      <InputNumber v-model="slotProps.data.qpmeNoisePower" :min="0" :max="1000" :allowEmpty="false"
                        aria-label="Sound Power Level" class="inputnumber field col-12 md:col-8" />
                      <Button
                        v-if="slotProps.data.qpmeNoisePower != slotProps.data.qpmeDefaultNoisePower && slotProps.data.qpmeNoisePower != 0"
                        icon="pi pi-upload" class="field col-12 md:col-4" @click="
                          showUploadDialog = true;
                        selectedEquipment = slotProps.data;
                        " style="margin: 0px; height: 30px" v-tooltip="'Upload support materials'" />
                    </div>
                    <label v-else-if="!slotProps.data.isQCM && getStage === 1">0</label>
                    <label v-else-if="slotProps.data.isQCM && getStage > 1">-</label>
                    <label v-else>{{ slotProps.data.qpmeNoisePower }}</label>
                  </template>
                </Column>
                <Column field="correctedSWL" header="Corrected Sound Power Level" :sortable="true"
                  style="min-width: 6%">
                  <template #body="slotProps">
                    <label>{{ slotProps.data.correctedSWL.toFixed(1) }}</label>
                  </template>
                </Column>
                <Column field="enclosureDba" header="Enclosure dB(A)" :sortable="true" style="min-width: 5.5%"
                  v-if="getStage === 3 || getIsReadOnly">
                  <template #body="slotProps">
                    <InputNumber v-model="slotProps.data.enclosureDba" :min="-20" :max="0" :allowEmpty="false"
                      class="inputnumber" style="width: 65px" aria-label="Enclosure dB(A)"
                      v-if="getIsReadOnly === false" showButtons />
                    <label v-else>{{ slotProps.data.enclosureDba }}</label>
                  </template>
                </Column>
                <Column field="barrierDba" header="Barrier dB(A)" :sortable="true" style="min-width: 4.5%"
                  v-if="getStage === 3 || getIsReadOnly">
                  <template #body="slotProps">
                    <InputNumber v-model="slotProps.data.barrierDba" :min="-15" :max="0" :allowEmpty="false"
                      class="inputnumber" style="width: 65px" aria-label="Barrier dB(A)" v-if="getIsReadOnly === false"
                      showButtons />
                    <label v-else>{{ slotProps.data.barrierDba }}</label>
                  </template>
                </Column>
                <!-- <Column field="hammerDba" header="Hammer Bracket dB(A)" :sortable="true"
                                    style="min-width:5%;" v-if="getStage === 3 || getIsReadOnly">
                                    <template #body="slotProps">
                                        <InputNumber v-model="slotProps.data.hammerDba" :min="-4" :max="0"
                                            class="inputnumber" style="width:30px;" v-if="getIsReadOnly === false" />
                                        <InputNumber v-model="slotProps.data.hammerDba" :min="-4" :max="0"
                                            class="inputnumber" style="width:30px;" disabled="true"
                                            v-else-if="getIsReadOnly === false" />
                                        <label v-else>{{ slotProps.data.hammerDba }}</label>
                                    </template>
                                </Column> -->
                <Column field="custommethoddba" header="Custom method dB(A)" :sortable="true" style="min-width: 5%"
                  v-if="getStage === 3 || getIsReadOnly">
                  <template #body="slotProps">
                    <InputNumber v-model="slotProps.data.custommethoddba" :min="-25" :max="0" :allowEmpty="false"
                      class="inputnumber" style="width: 65px" aria-label="Custom method dB(A)"
                      v-if="getIsReadOnly === false" showButtons />
                    <label v-else>{{ slotProps.data.custommethoddba }}</label>
                  </template>
                </Column>
                <Column field="custommethodname" header="Custom method name" :sortable="true" style="min-width: 12%"
                  v-if="getStage === 3 || getIsReadOnly">
                  <template #body="slotProps">
                    <InputText v-model="slotProps.data.custommethodname" class="inputnumber"
                      aria-label="Custom method name" type="text" style="width: 150px" v-if="getIsReadOnly === false" />
                    <InputText v-model="slotProps.data.custommethodname" class="inputnumber"
                      aria-label="Custom method name" style="width: 150px" disabled="true" type="text"
                      v-else-if="getIsReadOnly === false" />
                    <label v-else>{{ slotProps.data.custommethodname }}</label>
                  </template>
                </Column>

                <Column field="totalReduction" header="Total Reduction" :sortable="true" style="min-width: 5.5%"
                  v-if="getStage === 3">
                  <template #body="slotProps">
                    <label>{{ slotProps.data.totalReduction }}</label>
                  </template>
                </Column>
                <Column field="mitigatedSWL" header="Mitigated Noise w/ qty" :sortable="true" style="min-width: 6%">
                  <template #body="slotProps">
                    <!-- <label>{{ slotProps.data.mitigatedSWL.toFixed(1) }}</label> -->
                    <label>{{ slotProps.data.swlAfterQTYMitigated.toFixed(1) }}</label>
                  </template>
                </Column>

                <Column header="Apply to same equipment" style="min-width: 4%">
                  <template #body="slotProps">
                    <Button aria-label="Apply the same mitigation for all of this equipment on this project."
                      @click="copyMitigationForEquipment(slotProps.data)" icon="pi pi-copy"
                      v-tooltip="'Apply the same mitigation for all of this equipment on this project.'" />
                  </template>
                </Column>

                <!-- <Column field="attachment" header="Attachment" style="min-width:8%;max-width:8%;">
                                    <template #body="slotProps">
                                        <InputText v-model="slotProps.data.attachment"  />
                                    </template>
                                </Column> -->
              </DataTable>
              <div class="field col-12 md:col-12"></div>
              <!-- <div class="field col-12 md:col-4">
                                <label>Last floor with noise level exceeds the criteria: {{ lastRedFloor }}.</label>
                                <label>This is floor number {{ lastRedFloor + 1}}. The bottom floor is floor 0 (Ground).</label>
                            </div>
                            <div class="field col-12 md:col-4">
                                <label>Approximate barrier height at 3 meter from the equipment: {{ barrierHeight.toFixed(1) }} meter.</label>
                                <label style="color:red;" v-if="barrierHeight > 7"> Barrier height is taller than 7 meters.</label>
                            </div> -->
              <div class="field col-12 md:col-8" v-if="lastRedFloor > -1 && getStage === 3"></div>
              <div class="field col-12 md:col-4" v-if="lastRedFloor > -1 && getStage === 3">
                <div>
                  <label>Total number of storey: {{ totalFloor }}.</label>
                </div>
                <div>
                  <label>Last floor with noise level exceeds the criteria: {{ lastRedFloor }}.</label>
                </div>
                <div><label>(G/F - 1, 1/F - 2 etc)</label></div>
                <div><label>(G/F - 1, 1/F - 2 etc)</label></div>
                <div>
                  <label>Approximate barrier height at 3 meter from the equipment: {{ barrierHeight.toFixed(1) }}
                    meter.</label>
                </div>
                <div><label style="color: red" v-if="barrierHeight > 7">Barrier height is more than 7 meters!</label>
                </div>
              </div>
            </div>
          </ScrollPanel>
        </TabPanel>
        <TabPanel header="All equipment">
          <!-- <ScrollPanel class="scrollContentPanel"> -->
          <DataTable :value="updatedMitigatedEquipmentsAll" class="p-datatable-sm" id="equipmentInput"
            :scrollable="true" scroll-direction="vertical" scroll-height="calc(60vh - 50px)" :paginator="true"
            :rows="50"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageDropdown"
            responsiveLayout="scroll" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
            <!-- <Column field="groupTask" header="Group - Task" ></Column> -->
            <Column field="groupTask" header="Tasks" :sortable="true" frozen style="min-width: calc(10% - 40px)">
            </Column>
            <Column field="exclusiveGroup" header="Group" :sortable="true" frozen style="min-width: calc(8% - 40px)">
            </Column>
            <Column field="pme" header="Equipment" :sortable="true" frozen style="min-width: 20%">
              <template #body="slotProps">
                <label v-if="slotProps.data.isQCM && getStage != 1">{{ slotProps.data.qpmename }}</label>
                <label v-else>{{ slotProps.data.pme }}</label>
              </template>
            </Column>

            <Column field="noisePower" header="Sound Power Level" :sortable="true" style="min-width: 4%; max-width: 4%">
              <template #body="slotProps">
                <label v-if="slotProps.data.isQCM && getStage != 1">{{ slotProps.data.qpmeNoisePower }}</label>
                <label v-else>{{ slotProps.data.noisePower }}</label>
              </template>
            </Column>
            <Column field="quantity" header="Qty" :sortable="true" style="min-width: 3%; max-width: 3%"> </Column>
            <Column field="timePercent" header="%" :sortable="true" style="min-width: 3%; max-width: 3%"> </Column>
            <Column field="qpmename" header="Quieter Construction Method" :sortable="true"
              style="min-width: 13%; max-width: 13%" v-if="getStage === 1">
              <template #body="slotProps">
                <div class="formgrid grid" style="width: 100%; min-width: 210px">
                  <CascadeSelect class="field col-12 md:col-10" v-model="slotProps.data.qpmename" :options="qcmList"
                    optionLabel="name" :optionGroupChildren="['equipments']" optionGroupLabel="name"
                    :placeholder="getIsCustomMethod(slotProps.data.qpmename) ? 'Custom' : 'Select a Method'"
                    optionValue="name" style="margin: 5px 0; height: 30px; max-width: 400px"
                    @change="updateQCMNoisePower(slotProps.data)" aria-label="Quieter Construction Method"
                    v-if="getIsReadOnly === false && getStage === 1">
                  </CascadeSelect>
                  <Button class="field col-12 md:col-1" icon="pi pi-minus" v-tooltip="'Remove'"
                    style="margin: 5px 0 5px 5px; height: 30px; width: 30px" aria-label="Remove Method" @click="
                      slotProps.data.qpmename = '';
                    slotProps.data.isQCM = false;
                    slotProps.data.qpmeNoisePower = 0;
                    " :disabled="!slotProps.data.isQCM"></Button>
                  <InputText class="field col-12" style="height: 30px" v-if="
                    getIsReadOnly === false && getStage === 1 && (slotProps.data.qpmename == 'Custom' || getIsCustomMethod(slotProps.data.qpmename))
                  " v-model="slotProps.data.customQCMName" aria-label="Custom Method"
                    @blur="updateCustomQCMNoisePower(slotProps.data)" placeholder="Custom Method">
                  </InputText>
                  <label v-else-if="slotProps.data.isQCM && (getIsReadOnly || getStage != 1)">{{ slotProps.data.qpmename
                  }}</label>
                </div>
              </template>
            </Column>
            <Column field="qpmename" header="QPME" :sortable="true" style="min-width: 12%; max-width: 12%"
              v-if="getStage > 1">
              <template #body="slotProps">
                <!-- <InputText v-model="slotProps.data.qpmename"   /> 
                                        <label v-if="slotProps.data.qpmeList.length <= 0">N/A</label>-->
                <label v-if="slotProps.data.isQCM">Quieter Construction Method Applied</label>
                <div v-else-if="getIsReadOnly === false && getStage === 2"
                  v-tooltip.top="'Select a QPME or Enter Customized Quiet Equipment Name'">
                  <Dropdown v-model="slotProps.data.qpmename" :options="slotProps.data.qpmeList"
                    placeholder="Select a QPME" aria-label="Select a QPME"
                    @change="updateQPMENoisePower(slotProps.data)" editable="true">
                  </Dropdown>
                  <label v-if="slotProps.data.qpmename.startsWith('QPME')">Please include model number</label>
                </div>
                <label v-else-if="getIsReadOnly || getStage === 3">{{ slotProps.data.qpmename }}</label>
              </template>
            </Column>
            <Column field="qpmeNoisePower" header="Sound Power Level" :sortable="true"
              style="min-width: 5%; max-width: 5%">
              <template #body="slotProps">
                <!-- <label v-if="slotProps.data.qpmeList.length <= 0">N/A</label> -->
                <InputNumber v-model="slotProps.data.qpmeNoisePower" :min="0" :max="1000" :allowEmpty="false"
                  class="inputnumber" style="width: 40px" aria-label="Sound Power Level" v-if="
                    (getIsReadOnly === false && getStage === 2 && !slotProps.data.isQCM) ||
                    (getStage === 1 && getIsCustomMethod(slotProps.data.qpmename) && slotProps.data.isQCM)
                  " />
                <label v-else-if="!slotProps.data.isQCM && getStage === 1">0</label>
                <label v-else-if="slotProps.data.isQCM && getStage > 1">-</label>
                <label v-else>{{ slotProps.data.qpmeNoisePower }}</label>
              </template>
            </Column>
            <Column field="correctedSWL" header="Corrected Sound Power Level" :sortable="true"
              style="min-width: 6%; max-width: 6%">
              <template #body="slotProps">
                <label>{{ slotProps.data.correctedSWL.toFixed(1) }}</label>
              </template>
            </Column>
            <Column field="enclosureDba" header="Enclosure dB(A)" :sortable="true" style="min-width: 5.5%"
              v-if="getStage === 3 || getIsReadOnly">
              <template #body="slotProps">
                <InputNumber v-model="slotProps.data.enclosureDba" :min="-20" :max="0" :allowEmpty="false"
                  class="inputnumber" style="width: 65px" aria-label="Enclosure dB(A)" v-if="getIsReadOnly === false"
                  showButtons />
                <InputNumber v-model="slotProps.data.enclosureDba" :min="-20" :max="0" :allowEmpty="false"
                  class="inputnumber" style="width: 65px" disabled="true" aria-label="Enclosure dB(A)"
                  v-else-if="getIsReadOnly === false" showButtons />
                <label v-else>{{ slotProps.data.enclosureDba }}</label>
              </template>
            </Column>
            <Column field="barrierDba" header="Barrier dB(A)" :sortable="true" style="min-width: 4.5%; max-width: 4.5%"
              v-if="getStage === 3 || getIsReadOnly">
              <template #body="slotProps">
                <InputNumber aria-label="Barrier dB(A)" v-model="slotProps.data.barrierDba" :min="-15" :max="0"
                  :allowEmpty="false" class="inputnumber" style="width: 65px" v-if="getIsReadOnly === false"
                  showButtons />
                <InputNumber v-model="slotProps.data.barrierDba" :min="-15" :max="0" :allowEmpty="false"
                  class="inputnumber" style="width: 65px" disabled="true" aria-label="Barrier dB(A)"
                  v-else-if="getIsReadOnly === false" showButtons />
                <label v-else>{{ slotProps.data.barrierDba }}</label>
              </template>
            </Column>
            <!-- <Column field="hammerDba" header="Hammer Bracket dB(A)" :sortable="true"
                            style="min-width:5%;max-width:5%;" v-if="getStage === 3 || getIsReadOnly">
                            <template #body="slotProps">
                                <InputNumber v-model="slotProps.data.hammerDba" :min="-4" :max="0" class="inputnumber"
                                    style="width:30px;" v-if="getIsReadOnly === false" />
                                <InputNumber v-model="slotProps.data.hammerDba" :min="-4" :max="0" class="inputnumber"
                                    style="width:30px;" disabled="true" v-else-if="getIsReadOnly === false" />
                                <label v-else>{{ slotProps.data.hammerDba }}</label>
                            </template>
                        </Column> -->
            <Column field="custommethoddba" header="Custom method dB(A)" :sortable="true"
              style="min-width: 5%; max-width: 5%" v-if="getStage === 3 || getIsReadOnly">
              <template #body="slotProps">
                <InputNumber v-model="slotProps.data.custommethoddba" :min="-25" :max="0" :allowEmpty="false"
                  class="inputnumber" style="width: 65px" aria-label="Custom method dB(A)"
                  v-if="getIsReadOnly === false" showButtons />
                <InputNumber v-model="slotProps.data.custommethoddba" :min="-25" :max="0" :allowEmpty="false"
                  class="inputnumber" style="width: 65px" aria-label="Custom method dB(A)" disabled="true"
                  v-else-if="getIsReadOnly === false" showButtons />
                <label v-else>{{ slotProps.data.custommethoddba }}</label>
              </template>
            </Column>
            <Column field="custommethodname" header="Custom method name" :sortable="true"
              style="min-width: 12%; max-width: 12%" v-if="getStage === 3 || getIsReadOnly">
              <template #body="slotProps">
                <InputText v-model="slotProps.data.custommethodname" class="inputnumber" type="text"
                  style="width: 150px" v-if="getIsReadOnly === false" aria-label="Custom Method Name" />
                <InputText v-model="slotProps.data.custommethodname" class="inputnumber" style="width: 150px"
                  disabled="true" aria-label="Custom Method Name" type="text" v-else-if="getIsReadOnly === false" />
                <label v-else>{{ slotProps.data.custommethodname }}</label>
              </template>
            </Column>
            <Column field="totalReduction" header="Total Reduction" :sortable="true"
              style="min-width: 5.5%; max-width: 5.5%" v-if="getStage === 3">
              <template #body="slotProps">
                <label>{{ slotProps.data.totalReduction }}</label>
              </template>
            </Column>
            <Column field="mitigatedSWL" header="Mitigated Noise w/ qty" :sortable="true"
              style="min-width: 6%; max-width: 6%">
              <template #body="slotProps">
                <!-- <label>{{ slotProps.data.mitigatedSWL.toFixed(1) }}</label> -->
                <label>{{ slotProps.data.swlAfterQTYMitigated.toFixed(1) }}</label>
              </template>
            </Column>

            <Column header="Apply to same equipment" style="min-width: 5%; max-width: 5%">
              <template #body="slotProps">
                <Button icon="pi pi-copy" @click="copyMitigationForEquipment(slotProps.data)"
                  aria-label="Apply the same mitigation for all of this equipment on this project."
                  v-tooltip="'Apply the same mitigation for all of this equipment on this project.'" />
              </template>
            </Column>

            <!-- <Column field="attachment" header="Attachment" style="min-width:8%;max-width:8%;">
                            <template #body="slotProps">
                                <InputText v-model="slotProps.data.attachment"  />
                            </template>
                        </Column> -->
          </DataTable>
          <!-- </ScrollPanel> -->
        </TabPanel>
      </TabView>
    </template>
    <template #footer>
      <div class="formgrid grid">
        <div class="field col-12">
          <ConfirmPopup></ConfirmPopup>
          <Button label="Back to Quieter Construction Method" @click="stage = 1" icon="pi pi-angle-left"
            style="float: left; margin-left: 30px" v-if="getStage === 2 && !getIsReadOnly" :disabled="isCalculating" />
          <Button label="Proceed with QPME" icon="pi pi-angle-right" style="float: right; margin-left: 30px"
            @click="fillQPME($event)" v-if="getStage === 1 && isCalculating === false && !getIsReadOnly" />
          <Button label="Proceed with noise barrier and enclosure" icon="pi pi-angle-right"
            style="float: right; margin-left: 30px" @click="fillMitigation($event)"
            v-if="getStage === 2 && isCalculating === false && !getIsReadOnly" />
          <Button label="Back to QPME" @click="stage = 2" icon="pi pi-angle-left" style="float: left; margin-left: 30px"
            v-if="getStage === 3 && !getIsReadOnly" :disabled="isCalculating" />
          <Button label="Calculate & Save" icon="pi pi-save" style="float: right" @click="save"
            v-if="isCalculating === false" />
          <Button label="Calculating..." icon="pi pi-spin pi-spinner"
            style="float: right; background: lightgray; background-color: lightgray; margin: 0 5px" v-if="isCalculating"
            :disabled="isCalculating" />
        </div>
      </div>
    </template>
  </Card>
  <Card class="card" v-if="showUploadDialog">
    <template #title>
      Support Materials
      <Button icon="pi pi-times" class="p-button-rounded p-button-secondary p-button-text"
        style="position: fixed; right: 10px" @click="showUploadDialog = false" />
    </template>
    <template #content>
      <div style="text-align: left">Please upload support materials for user defined sound power:</div>
      <SupportMaterialTable
        :equipments="updatedMitigatedEquipments.filter((fe) => fe.qpmeDefaultNoisePower != fe.qpmeNoisePower && fe.qpmeNoisePower != 0)"
        :project="project" :disabled="project.readonly" mode="qpme">
      </SupportMaterialTable>
    </template>
  </Card>
</template>

<script>
import MapOL from "@/libs/myOpenLayers.js";
import { ref, reactive } from "vue";
import SupportMaterialTable from "@/components/report module/SupportMaterialTable.vue";
export default {
  components: {
    SupportMaterialTable,
  },
  data() {
    return {
      project: this.getCurrentProject(),
      mitigatedEquipments: [],
      mitigatedEquipmentsAll: [],
      groupResultList: [],
      groupResultListForDistances: [],
      calculationResultList: [],
      isCalculated: 0,
      selectedRank: 1,
      currentGroupResult: null,
      currentGroupResultUnmitigated: null,
      rankOption: [],
      nsrRankOption: [],
      equipmentList: [],
      qpmeList: [],
      qpmeRelPMEList: [],
      relatedPMEList: [],
      zoneTaskList: [],
      filteredGroupResultList: [],
      fixedLocationFeatures: [],
      zoneCentroidDictionary: [],

      savedStartDate: "",
      savedEndDate: "",

      currentRankNSRBuildingId: "",
      currentRankNSRBuildingName: "",

      lastRedFloor: -1,
      barrierHeight: -1,
      totalFloor: -1,

      tabActiveIndex: 0,
      isCalculating: false,

      stage: 1,

      // custDictionary: null,

      currentSelectedBuildingId: 0,
      currentSelectedZoneTaskArr: [],

      qcmList: [],
      qcmEquipmentList: [],

      showUploadDialog: false,
      selectedEquipment: null,
    };
  },
  computed: {
    getCurrentTotalUnmitigatedCnl() {
      let props = this;
      return this.project.calculationResultNSR.filter((c) => !c.ismitigated && c.nsrname == props.selectedRank.nsrname).length
        ? this.project.calculationResultNSR.filter((c) => !c.ismitigated && c.nsrname == props.selectedRank.nsrname)[0].highestnoiselevel
        : 0;
    },
    getCurrentTotalCnl() {
      return this.currentGroupResult ? this.currentGroupResult.highestnoiselevel.toFixed(1) : "0";
    },
    getCurrentNoiseCriteria() {
      return this.currentGroupResult ? this.currentGroupResult.noiseCriteria : "0";
    },
    getCurrentNoiseResultText() {
      return this.currentGroupResult
        ? Math.round(this.currentGroupResult.highestnoiselevel) - Math.round(this.currentGroupResult.noiseCriteria) > 0
          ? "Exceed buliding noise criteria"
          : "Satisfy building noise criteria"
        : "";
    },
    getCredit() {
      let qcm = this.updatedMitigatedEquipments.filter((e) => e.isQCM);
      return qcm.length >= 2;
    },
    getCurrentStartDate() {
      return this.currentGroupResult ? this.currentGroupResult.startDate : "1111-1-1";
    },
    getCurrentEndDate() {
      return this.currentGroupResult ? this.currentGroupResult.endDate : "1111-1-1";
    },
    getCurrentBuildingid() {
      return this.currentGroupResult ? this.currentGroupResult.buildingid : "";
    },
    getCurrentBuildingName() {
      return this.currentGroupResult ? this.currentGroupResult.buildingName : "";
    },
    getCurrentNSRName() {
      return this.currentGroupResult ? this.currentGroupResult.nsrname : "";
    },
    getCurrentNSRPointId() {
      return this.currentGroupResult ? this.currentGroupResult.nsrpointid : "";
    },
    getIsReadOnly() {
      var curProj = this.$store.getters.currentProject;
      console.log("curProj.readonly");
      console.log(curProj.readonly);
      if (typeof curProj.readonly === "undefined") {
        return false;
      } else {
        return curProj.readonly;
      }
    },
    getStage() {
      return this.stage;
    },
    updatedMitigatedEquipments() {
      let props = this;
      this.mitigatedEquipments.forEach((item, index) => {
        let calculationResult = MapOL.getCalculationResultNSR().filter(
          (c) => c.nsrname == props.selectedRank.nsrname && c.zonetaskorcombined == `${item.zone}-${item.task}`,
        )[0];
        item.groupTask = item.zone + "-" + item.task + ": " + item.group + " - " + item.taskname;
        item.timePercentCorrection = 10 * Math.log10(item.timePercent / 100);
        item.correctedSWL =
          item.qpmeNoisePower <= 0 && !item.isQCM
            ? item.noisePower + item.timePercentCorrection
            : (item.noisePower <= 0 ? item.qpmeNoisePower : Math.min(item.noisePower, item.qpmeNoisePower)) + item.timePercentCorrection;
        item.correctedSWL = item.correctedSWL <= 0 ? 0 : item.correctedSWL;
        item.totalReduction = Math.min(item.enclosureDba, item.barrierDba, item.hammerDba, item.custommethoddba);
        item.mitigatedSWL = item.correctedSWL + item.totalReduction;
        item.mitigatedSWL = item.mitigatedSWL <= 0 || item.correctedSWL <= 0 ? 0 : item.mitigatedSWL;
        item.swlAfterQTYMitigated = item.mitigatedSWL + 10 * Math.log10(item.quantity);
        item.swlAfterQTYMitigated = item.mitigatedSWL <= 0 ? 0 : item.swlAfterQTYMitigated;
        item.contribution =
          item.swlAfterQTYMitigated + calculationResult.distancecorr + calculationResult.facadecorr < 0
            ? 0
            : item.swlAfterQTYMitigated + calculationResult.distancecorr + calculationResult.facadecorr;
        item.attachment = "";
        item.customQCMName = this.getIsCustomMethod(item.qpmename) ? item.qpmename : "";
      });
      return this.mitigatedEquipments;
    },
    updatedMitigatedEquipmentsAll() {
      this.mitigatedEquipmentsAll.forEach((item, index) => {
        item.groupTask = item.zone + "-" + item.task + ": " + item.group + " - " + item.taskname;
        item.timePercentCorrection = 10 * Math.log10(item.timePercent / 100);
        item.correctedSWL =
          item.qpmeNoisePower <= 0 && !item.isQCM
            ? item.noisePower + item.timePercentCorrection
            : (item.noisePower <= 0 ? item.qpmeNoisePower : Math.min(item.noisePower, item.qpmeNoisePower)) + item.timePercentCorrection;
        item.correctedSWL = item.correctedSWL <= 0 ? 0 : item.correctedSWL;
        item.totalReduction = Math.min(item.enclosureDba, item.barrierDba, item.hammerDba, item.custommethoddba);
        item.mitigatedSWL = item.correctedSWL + item.totalReduction;
        item.mitigatedSWL = item.mitigatedSWL <= 0 || item.correctedSWL <= 0 ? 0 : item.mitigatedSWL;
        item.swlAfterQTYMitigated = item.mitigatedSWL + 10 * Math.log10(item.quantity);
        item.swlAfterQTYMitigated = item.mitigatedSWL <= 0 ? 0 : item.swlAfterQTYMitigated;
        // item.contribution = item.swlAfterQTYMitigated + item.distancecorr + item.facadecorr;
        item.attachment = "";
        item.customQCMName = this.getIsCustomMethod(item.qpmename) ? item.qpmename : "";
      });
      return this.mitigatedEquipmentsAll;
    },
  },
  methods: {
    getCurrentProject() {
      console.log("currentProject");
      console.log(this.$store.getters.currentProject);
      return this.$store.getters.currentProject;
    },
    getQPMEOption(rowdata) {
      var currentOption = [];
      this.equipmentList.forEach((item) => {
        if (item.name === rowdata.otherName) {
          currentOption = item.qpmeList;
        }
      });
      return currentOption;
    },
    close() {
      this.$router.replace({ path: "/" });
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-").toString();
    },
    fillQPME(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message:
          "Please consider to use the Quieter Construction Method before considering the use of QPME. Have you reviewed all Quieter Construction Method option for all equipment?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          //callback to execute when user confirms the action
          this.save();
          this.stage = 2;
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
        onShow: () => {
          //callback to execute when popup is shown
        },
        onHide: () => {
          //callback to execute when popup is hidden
        },
      });
    },
    fillMitigation(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message:
          "Please consider to use QPME before considering the use of noise barrier and enclosure. Have you reviewed all QPME option for all equipment?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          //callback to execute when user confirms the action
          this.stage = 3;
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
        onShow: () => {
          //callback to execute when popup is shown
        },
        onHide: () => {
          //callback to execute when popup is hidden
        },
      });
    },
    save() {
      this.isCalculating = true;
      //update the mitigated ectivities that contain -5 barrier for barrier height label
      var barrieredZoneTaskArr = [];
      for (let i = 0; i < this.updatedMitigatedEquipmentsAll.length; i++) {
        var aMitEqp = this.updatedMitigatedEquipmentsAll[i];
        if (aMitEqp.barrierDba < 0) {
          var taskName = aMitEqp.groupTask;
          var zoneTaskId = taskName.split(":")[0].trim();
          if (!barrieredZoneTaskArr.includes(zoneTaskId)) {
            barrieredZoneTaskArr.push(zoneTaskId);
          }
        }
      }
      console.log(this.currentGroupResult);
      MapOL.setBuildingIdForMitigation(this.getCurrentBuildingid, barrieredZoneTaskArr);

      this.updateIsCalculatedOnProject(0, this.save2);
    },
    save2() {
      let props = this;
      console.log("props.project.equipments");
      console.log(props.project.equipments);

      // Prepare equipment data to send
      const equipmentData = props.project.equipments.map((e) => {
        return {
          qpmename: e.qpmename,
          qpmeNoisePower: e.qpmeNoisePower,
          enclosureDba: e.enclosureDba,
          barrierDba: e.barrierDba,
          hammerDba: e.hammerDba,
          custommethoddba: e.custommethoddba,
          custommethodname: e.custommethodname,
          isQCM: e.isQCM,
          id_0: e.id_0,
        };
      });

      // Split equipment into batches of 5 to avoid payload too large error
      const batchSize = 5;
      const equipmentBatches = [];
      for (let i = 0; i < equipmentData.length; i += batchSize) {
        equipmentBatches.push(equipmentData.slice(i, i + batchSize));
      }

      // Process batches sequentially
      let allResponses = [];
      const processBatch = async (batchIndex) => {
        if (batchIndex >= equipmentBatches.length) {
          // All batches processed successfully
          console.log("All batches processed", allResponses);
          console.log("saved");

          //re-calculate
          MapOL.calculateNoise(props.project, null);
          props.waitUntilIsCalculatedIsOne(props.initMitigatedEquipments);
          return;
        }

        // Process current batch
        props.axios
          .post(`${props.apiEndpoint}projectpme?projectid=${props.project.id}&isMitigated=1`, equipmentBatches[batchIndex])
          //.post(`https://localhost:44384/projectpme?projectid=${props.project.id}&isMitigated=1`, equipmentBatches[batchIndex])
          .then(function (response) {
            console.log(`Batch ${batchIndex + 1}/${equipmentBatches.length} completed`, response);
            allResponses = allResponses.concat(response.data);
            // Process next batch
            processBatch(batchIndex + 1);
          })
          .catch((error) => {
            console.log(error);
          });
      };

      // Start processing from first batch
      processBatch(0);
    },

    updateQPMENoisePower(rowData) {
      // this.mitigatedEquipments.forEach((item, index) => {
      //     var theName = item.qpmename;
      //     if(item.qpmename.includes(" - ")){
      //         var names = item.qpmename.split(" - ");
      //         theName = names[1];
      //     }
      //     item.qpmeNoisePower = this.getPMESWLByName(theName);
      // });
      var theName = rowData.qpmename;
      if (theName.includes(" - ")) {
        var names = theName.split(" - ");
        theName = names[1];
      }
      rowData.qpmeNoisePower = this.getPMESWLByName(theName);
      rowData.qpmeDefaultNoisePower = this.getPMESWLByName(theName);
    },

    updateQCMNoisePower(rowData) {
      var theName = rowData.qpmename;
      if (theName.includes(" - ")) {
        var names = theName.split(" - ");
        theName = names[1];
      }
      rowData.qpmeNoisePower = this.getPMESWLByName(theName);
      rowData.qpmeDefaultNoisePower = this.getPMESWLByName(theName);
      rowData.isQCM = true;
    },

    updateCustomQCMNoisePower(rowData) {
      rowData.qpmename = rowData.customQCMName;
      rowData.isQCM = true;
    },
    updateQPMENoisePowerAll(rowData) {
      // this.mitigatedEquipmentsAll.forEach((item, index) => {
      //     var theName = item.qpmename;
      //     if(item.qpmename.includes(" - ")){
      //         var names = item.qpmename.split(" - ");
      //         theName = names[1];
      //     }
      //     item.qpmeNoisePower = this.getPMESWLByName(theName);
      // });
      var theName = rowData.qpmename;
      if (theName.includes(" - ")) {
        var names = theName.split(" - ");
        theName = names[1];
      }
      rowData.qpmeNoisePower = this.getPMESWLByName(theName);
    },
    reCalculatePromise() {
      return new Promise((resolve) => {
        MapOL.calculateNoise(this.project, null);
        resolve();
      });
    },
    test() {
      console.log("nsde test");
      console.log("this.savedStartDate");
      console.log(this.savedStartDate);
      console.log("this.savedEndDate");
      console.log(this.savedEndDate);
      var frl = this.groupResultListFiltered();
      var index = -1;
      console.log("frl");
      console.log(frl);
      for (let j = 0; j < frl.length; j++) {
        var testcurrentGroupResult = frl[j];
        var firstStartDate = this.formatDate(testcurrentGroupResult.startDate);
        var firstEndDate = this.formatDate(testcurrentGroupResult.endDate);
        console.log("firstStartDate");
        console.log(firstStartDate);
        if (firstStartDate === this.formatDate(this.savedStartDate) && firstEndDate === this.formatDate(this.savedEndDate)) {
          index = testcurrentGroupResult.totalcnl;
          break;
        }
      }
      console.log("index");
      console.log(index);
    },
    updateIsCalculatedOnProject(value, callback) {
      var objToSent = {
        id: this.project.id,
        iscalculated: value,
      };
      let props = this;
      props.axios
        .post(`${props.apiEndpoint}Project/iscalculated`, objToSent)
        .then(function (response) {
          if (callback) {
            console.log("updateIsCalculatedOnProject finished. calling callback");
            callback();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    waitUntilIsCalculatedIsOne(callback) {
      let props = this;
      props.axios
        .get(`${props.apiEndpoint}project/iscalculated/${props.project.id}`)
        .then(function (response) {
          if (response.data <= 0) {
            console.log(response.data);
            setTimeout(function () {
              props.waitUntilIsCalculatedIsOne(callback);
            }, 1000);
          } else {
            console.log(response.data);
            callback();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkCalculationDone(callback) {
      let props = this;
      props.axios
        .get(`${props.apiEndpoint}project/iscalculated/${props.project.id}`)
        .then(function (response) {
          var isCalculated = response.data;
          if (isCalculated === "0") {
            // if calculation not yet done, run the calculation
            console.log("Calculating noise of project id: " + props.project.id.toString());
            MapOL.calculateNoise(props.project, callback);
            if (callback) {
              callback();
            }
          } else {
            if (callback) {
              callback();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCalculationGroupsResult(callback) {
      console.log("inside getCalculationGroupsResult");
      let props = this;
      console.log("props.project.id", props.project.id);
      props.axios
        //.get(`${props.apiEndpoint}CalculationResultGroup?projectid=${props.project.id}`)

        .get(`${props.apiEndpoint}CalculationResultNSR/mitigated/${props.project.id}`)
        //.get(`https://localhost:44384/CalculationResultNSR/mitigated/${props.project.id}`)
        .then(function (response) {
          props.groupResultList = response.data;
          // props.groupResultList = MapOL.getCalculationResult().filter(c => c.ismitigated);
          console.log("props.groupResultList");
          console.log(props.groupResultList);

          //check if we have selected building ID to mitigate (from pop-up).
          console.log("MapOL.getBuildingIdForMitigation();");
          console.log(MapOL.getBuildingIdForMitigation());
          var buildingidToShow = MapOL.getBuildingIdForMitigation();
          if (buildingidToShow > 0) {
            var tempResultList = [];
            response.data.forEach((e) => {
              if (e.buildingid === buildingidToShow) {
                tempResultList.push(e);
              }
            });
            if (tempResultList.length > 0) {
              props.groupResultList = tempResultList;
            }
          }
          console.log("buildingidToShow");
          console.log(buildingidToShow);

          //check if we have selected nsrname.
          var tempResultList2 = [];
          props.groupResultList.forEach((e) => {
            var names = MapOL.getNSRNameAndBuildingNameFromNSRPointIDAndBuildingId(e.nsrpointid, e.buildingid);
            e.nsrname = names[0];
            e.buildingName = names[1];
            tempResultList2.push(e);
          });
          if (tempResultList2.length > 0) {
            props.groupResultList = tempResultList2;
          }

          //put the .calculationResultNSR from myOpenLayers.js to ths.project
          props.project.calculationResultNSR = MapOL.getCalculationResultNSR().filter((c) => c.ismitigated);

          console.log(props.project.calculationResultNSR);
          props.iniQPMERelPME(props.initEquipments);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCalculationGroupsResult2(callback) {
      console.log("inside getCalculationGroupsResult");
      console.log("this.project.id", this.project.id);
      this.nsrRankOption = [];
      this.project.calculationResultNSR = MapOL.getCalculationResultNSR();

      console.log(this.project.calculationResultNSR);

      let tempRank =
        MapOL.getCalculationResultNSR().filter((c) => c.ismitigated && c.cnl == c.highestnoiselevel).length === 0
          ? MapOL.getCalculationResultNSR().filter((c) => c.cnl == c.highestnoiselevel)
          : MapOL.getCalculationResultNSR().filter((c) => c.ismitigated && c.cnl == c.highestnoiselevel);

      tempRank.forEach((r) => {
        // let exists = this.nsrRankOption.filter(r1 => `${r1.nsrname}${r1.highestnoiselevel}` === `${r.nsrname}${r.highestnoiselevel}`).length
        let exists = this.nsrRankOption.filter((r1) => r1.nsrname === r.nsrname).length;
        if (!exists) {
          this.nsrRankOption.push(r);
        }
      });

      this.nsrRankOption.sort((a, b) => b.highestnoiselevel - a.highestnoiselevel);

      let buildingidToShow = MapOL.getBuildingIdForMitigation();

      if (buildingidToShow > 0) {
        this.selectedRank = this.nsrRankOption.filter((r) => r.buildingid == buildingidToShow)[0];
      } else {
        this.selectedRank = this.nsrRankOption[0];
      }

      this.initQPME(this.initEquipments);
    },
    initMitigatedEquipments() {
      this.checkCalculationDone(this.getCalculationGroupsResult2);
      //this.iniQPMERelPME(this.initEquipments);
    },
    initQPME(callback) {
      let props = this;
      props.axios.get(`${props.apiEndpoint}pme/qpme`).then((response) => {
        props.qpmeList = response.data;
        if (callback) {
          callback();
        }
      });
    },
    iniQPMERelPME(callback) {
      console.log("enter iniQPMERelPME");
      let props = this;
      props.axios
        .get(`${props.apiEndpoint}QPMEMatchPME`)
        .then(function (response) {
          props.qpmeRelPMEList = response.data;
          props.relatedPMEList = [];
          response.data.forEach((e) => {
            props.relatedPMEList.push(e.pmeid);
          });

          if (callback) {
            callback();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    initEquipments(callback) {
      console.log("enter initEquipments");
      let props = this;
      props.axios
        .get(`${props.apiEndpoint}pme`)
        .then(function (response) {
          props.equipmentList = response.data;
          props.zoneTaskList = [];
          props.filteredGroupResultList = [];
          console.log("groupResultList", props.nsrRankOption);
          props.nsrRankOption.forEach((e) => {
            if (!props.zoneTaskList.includes(e.zonetaskorcombined)) {
              props.zoneTaskList.push(e.zonetaskorcombined);
              props.filteredGroupResultList.push(e);
            }
          });
          console.log("zoneTaskList", props.zoneTaskList);

          // props.qpmeRelPMEList.forEach(e => {
          //     e.pmename = props.getPMENameByID(e.pmeid);
          //     e.qpmename = props.getPMENameByID(e.qpmeid);
          //     e.qpmeswl = props.getPMEByID(e.qpmeid).noisePower;
          // });

          props.project.equipments.forEach((e) => {
            // var suitableQPME = props.getQPMERelNameByName(e.otherName);

            // e.qpmeList = suitableQPME.filter(q => !q.startsWith('CNP'));
            // e.allEqpList = suitableQPME;

            e.qpmeList = props.qpmeList.map((q) => q.name);
            e.allEqpList = props.qpmeList;
          });

          //obtain PME list for allEqpList in addition to QPME
          var theFields = ["officialId", "e.name"];
          props.equipmentList.sort(props.dynamicSortMultiple(theFields));
          console.log("props.project.equipments");
          console.log(props.project.equipments);
          props.equipmentList.forEach((e) => {
            props.project.equipments.forEach((f) => {
              if (e.isQPME === false && e.officialId != "" && e.noisePower < f.noisePower) {
                f.allEqpList.push(e.officialId != "" ? e.officialId + " - " + e.name : e.name);
              }
            });
          });
          props.equipmentList.forEach((e) => {
            props.project.equipments.forEach((f) => {
              if (e.isQPME === false && e.officialId == "" && e.noisePower < f.noisePower) {
                f.allEqpList.push(e.officialId != "" ? e.officialId + " - " + e.name : e.name);
              }
            });
          });

          // this is to set the all equipment tab content
          var eqpWithTaskArr = props.project.equipments;
          eqpWithTaskArr.forEach((item, index) => {
            item.taskname = props.getTaskFromTaskId(item.task);
          });
          var tempMitAllSorted = eqpWithTaskArr.sort(function (a, b) {
            let x = a.exclusiveGroup.toLowerCase();
            let y = b.exclusiveGroup.toLowerCase();
            if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          });
          props.mitigatedEquipmentsAll = [];
          for (let l = 0; l < tempMitAllSorted.length; l++) {
            props.mitigatedEquipmentsAll.push(tempMitAllSorted[l]);
          }

          props.setCurrentRankParameters(1);
          // props.project.equipments.forEach(e => {
          //     var suitableQPME = [];

          //     if (props.relatedPMEList.includes(e.id)){
          //         props.qpmeRelPMEList.forEach(item => {
          //             // console.log("e.id");
          //             // console.log(e.id);
          //             // console.log("item.pmeid");
          //             // console.log(item.pmeid);
          //             if (item.pmeid === e.id) {
          //                 var qpmeObj = props.getPMEByID(item.qpmeid)

          //                 if ( qpmeObj != null)
          //                 {
          //                     suitableQPME.push(qpmeObj);
          //                 }
          //             }
          //         })
          //     }
          //     e.qpmeList = suitableQPME;
          // })
          // props.equipmentList = response.data;
          // console.log("props.equipmentList");
          // console.log(props.equipmentList);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPMEByID(id) {
      var theObj = null;
      this.equipmentList.forEach((item) => {
        if (item.id === id) {
          theObj = item;
        }
      });
      return theObj;
    },
    getPMENameByID(id) {
      return this.getPMEByID(id).name;
    },
    getQPMERelByName(name) {
      var theObjArr = [];
      this.qpmeRelPMEList.forEach((item) => {
        if (item.pmename === name) {
          theObjArr.push(item);
        }
      });
      return theObjArr;
    },
    getQPMERelNameByName(name) {
      var theObjArr = [];
      this.qpmeRelPMEList.forEach((item) => {
        if (item.pmename === name) {
          theObjArr.push("QPME - " + item.qpmename);
        }
      });
      return theObjArr;
    },
    getPMESWLByName(name) {
      var theObj = 0;
      this.equipmentList.forEach((item) => {
        if (item.name === name) {
          theObj = item.noisePower;
        }
      });
      return theObj;
    },
    checkGroupResultIndexByDates(groupResultList, startDate, endDate) {
      var dx = -1;
      for (let i = 0; i < groupResultList.length; i++) {
        var currItem = groupResultList[i];
        if (this.formatDate(currItem.startDate) === this.formatDate(startDate) && this.formatDate(currItem.endDate) === this.formatDate(endDate)) {
          dx = i + 1;
          break;
        }
      }
      return dx;
    },
    setCurrentRankParameters(rankIndex) {
      console.log("Enter setCurrentRankParameters");
      // var frl = this.groupResultListFiltered();

      // // if from saved = savedstart date and savedEndDate exst.
      // if(this.savedStartDate != "" && this.savedEndDate !="") {
      //     var tempndex = this.checkGroupResultIndexByDates(frl,this.savedStartDate,this.savedEndDate);
      //     if(tempndex>0) {
      //         rankIndex = tempndex;
      //         this.savedStartDate = "";
      //         this.savedEndDate = "";
      //     }
      // }
      // this.selectedRank = rankIndex;
      // this.currentGroupResult = frl[rankIndex-1];
      // console.log("rankIndex",rankIndex);
      var eqpWithTaskArr = this.project.equipments;
      // eqpWithTaskArr.forEach((item, index) => {
      //     item.taskname = this.getTaskFromTaskId(item.task);
      // });
      console.log("this.zoneTaskList");
      console.log(this.zoneTaskList);

      // var currentZoneTask = this.zoneTaskList[rankIndex - 1];
      //console.log("currentZoneTask",currentZoneTask);
      let props = this;
      var zoneTaskArr = [
        ...new Set(
          MapOL.getCalculationResultNSR()
            .filter((c) => c.ismitigated && c.nsrname == props.selectedRank.nsrname && !c.zonetaskorcombined.includes("+"))
            .map((c) => c.zonetaskorcombined),
        ),
      ];
      this.currentSelectedZoneTaskArr = zoneTaskArr;

      this.mitigatedEquipments = [];

      // this.mitigatedEquipmentsAll = [];
      for (let j = 0; j < zoneTaskArr.length; j++) {
        var zoneOrTaskArr = zoneTaskArr[j].split("-");
        var aZone = parseInt(zoneOrTaskArr[0]);
        var aTask = zoneOrTaskArr[1];

        var tempMit = eqpWithTaskArr.filter((eqp) => eqp.zone === aZone && eqp.task === aTask);
        //console.log("tempMit",tempMit);

        // var tempMitAll = eqpWithTaskArr;
        //now sort accordng to exclusve group
        var tempMitSorted = tempMit.sort(function (a, b) {
          let x = a.exclusiveGroup.toLowerCase();
          let y = b.exclusiveGroup.toLowerCase();
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
        // var tempMitAllSorted = tempMitAll.sort(function(a, b){
        //         let x = a.exclusiveGroup.toLowerCase();
        //         let y = b.exclusiveGroup.toLowerCase();
        //         if (x < y) {return -1;}
        //         if (x > y) {return 1;}
        //         return 0;
        //     });
        for (let l = 0; l < tempMitSorted.length; l++) {
          this.mitigatedEquipments.push(tempMitSorted[l]);
        }
        // for(let l=0; l <tempMitAllSorted.length; l++) {
        //     this.mitigatedEquipmentsAll.push(tempMitAllSorted[l]);
        // }
      }

      //get the calc nsr result for the frst row that has zone task = currentZoneTask
      // for (let j = 0; j < this.filteredGroupResultList.length; j++) {
      //     var nsrResult = this.filteredGroupResultList[j];
      //     if (nsrResult.zonetaskorcombined === currentZoneTask) {
      //         this.currentGroupResult = nsrResult;
      //         break;
      //     }
      // }
      var selectedBuildingId = this.selectedRank.buildingid;
      this.currentSelectedBuildingId = selectedBuildingId;
      var selectedzonetaskorcombined = this.selectedRank.zonetaskorcombined;
      var selectedzonetaskorcombinedArr = selectedzonetaskorcombined.split("+");
      var selectedBuildingNoiseCriteria = this.selectedRank.noisecriteria;
      this.lastRedFloor = this.selectedRank.lastredfloor;
      this.barrierHeight = this.selectedRank.barrierheight;
      this.totalFloor = this.selectedRank.totalfloor;
      var bldHeight = MapOL.getBuildingHeight(selectedBuildingId);
      var assumptionHeightPerFloor = 3;
      //check if there is -5 barrer dba
      var minFiveBarFound = false;
      for (let m = 0; m < this.updatedMitigatedEquipmentsAll.length; m++) {
        var curEqpObj = this.updatedMitigatedEquipmentsAll[m];
        if (curEqpObj.barrierDba < 0) {
          minFiveBarFound = true;
        }
      }
      // console.log("minFiveBarFound");
      // console.log(minFiveBarFound);
      // console.log("this.lastRedFloor");
      // console.log(this.lastRedFloor);
      if (this.lastRedFloor <= 0 && minFiveBarFound) {
        this.calculateBarrierHeight(
          this.project.calculationResultNSR,
          selectedBuildingNoiseCriteria,
          this.totalFloor,
          bldHeight,
          assumptionHeightPerFloor,
        );
      } else if (this.lastRedFloor > 0 && minFiveBarFound) {
        //do nothng
      } else {
        this.lastRedFloor = -1;
        this.barrierHeight = 0;
      }

      // ### set the buldng d and barrered zone tas for myOpenLayers.js
      //update the mitigated ectivities that contain -5 barrier for barrier height label
      var barrieredZoneTaskArr = [];
      for (let i = 0; i < this.updatedMitigatedEquipmentsAll.length; i++) {
        var aMitEqp = this.updatedMitigatedEquipmentsAll[i];
        if (aMitEqp.barrierDba < 0) {
          var taskName = aMitEqp.groupTask;
          var zoneTaskId = taskName.split(":")[0].trim();
          if (!barrieredZoneTaskArr.includes(zoneTaskId)) {
            barrieredZoneTaskArr.push(zoneTaskId);
          }
        }
      }

      MapOL.setBuildingIdForMitigation(this.getCurrentBuildingid, barrieredZoneTaskArr);

      //get the distance for contribution calculation
      var filteredCalcResultListForDistances = this.project.calculationResultNSR.filter(
        (eqp) =>
          eqp.projectid === this.project.id &&
          eqp.buildingid === selectedBuildingId &&
          selectedzonetaskorcombinedArr.includes(eqp.zonetaskorcombined),
      );
      var theSortFields = ["-highestnoiselevel-noisecriteria", "zonetaskorcombined"];
      filteredCalcResultListForDistances.sort(this.dynamicSortMultiple(theSortFields));

      //props.groupResultListForDistances = response.data;
      this.groupResultListForDistances = filteredCalcResultListForDistances;
      for (let m = 0; m < this.mitigatedEquipments.length; m++) {
        var anItem = this.mitigatedEquipments[m];
        var zoneTaskItem = anItem.zone + "-" + anItem.task;

        var notFound = true;
        for (let k = 0; k < this.groupResultListForDistances.length; k++) {
          var aDistanceResult = this.groupResultListForDistances[k];

          if (aDistanceResult.excgroups.includes(anItem.id_0.toString())) {
            //fixed
            anItem.distance = aDistanceResult.distance;
            anItem.distancecorr = aDistanceResult.distancecorr;
            anItem.facadecorr = aDistanceResult.facadecorr;
            notFound = false;
          } else if (aDistanceResult.excgroups === anItem.exclusiveGroup) {
            // notional
            anItem.distance = aDistanceResult.distance;
            anItem.distancecorr = aDistanceResult.distancecorr;
            anItem.facadecorr = aDistanceResult.facadecorr;
            notFound = false;
          }
        }
        if (notFound) {
          for (let k = 0; k < this.groupResultListForDistances.length; k++) {
            var aDistanceResult = this.groupResultListForDistances[k];
            if (aDistanceResult.zonetaskorcombined === zoneTaskItem) {
              // notional - for the whole zone task that does not have fixed in any exc group
              anItem.distance = aDistanceResult.distance;
              anItem.distancecorr = aDistanceResult.distancecorr;
              anItem.facadecorr = aDistanceResult.facadecorr;
            }
          }
        }
      }

      this.isCalculating = false;
    },
    groupResultListFiltered() {
      var filteredResultList = [];
      var filteredDateList = [];

      var totArr = 0;
      this.groupResultList.forEach((item, index) => {
        var currentDateSignature = item.startDate.toString() + item.endDate.toString();
        //if( !filteredDateList.includes(currentDateSignature) && item.totalcnl >= item.noiseCriteria) { // becareful when all totalcnl < noisecriteria. no data to bind to datatable.
        if (!filteredDateList.includes(currentDateSignature)) {
          filteredDateList.push(currentDateSignature);
          filteredResultList.push(item);
          totArr = totArr + 1;
        }

        f;
      });
      return filteredResultList;
      //return "groupResultListFiltered";
    },

    calculateBarrierHeight(
      calculationResultMitigatedNSRArray,
      currentNoiseCriteria,
      currentlBuildingTotalFloor,
      currentlBuildingHeight,
      heightPerFloor,
    ) {
      console.log("Entering calculateBarrierHeight on mitigationView");
      //use buildingid and zonetaskid from global var: buildingIdForMitigation , zoneTaskIdsForMitigation

      var combinedZoneTaskArr = [];
      var barrieredZoneTaskArr = [];
      var cnlPerFloor = [];
      var nonBarrierCNL = [];
      var horizontalDistance = 0;
      for (let i = 0; i < calculationResultMitigatedNSRArray.length; i++) {
        var currentCalcResultNSR = calculationResultMitigatedNSRArray[i];

        var currentBuildingId = currentCalcResultNSR.buildingid;
        var currentIsmitigated = currentCalcResultNSR.ismitigated;
        var currentZonetaskorcombined = currentCalcResultNSR.zonetaskorcombined;

        if (currentIsmitigated === true && currentBuildingId === this.currentSelectedBuildingId) {
          if (currentZonetaskorcombined.includes("+")) {
            var zoneTaskDict = MapOL.newCustDictionary(currentZonetaskorcombined, null, null);
            combinedZoneTaskArr.push(zoneTaskDict);
          } else {
            if (this.currentSelectedZoneTaskArr.includes(currentZonetaskorcombined)) {
              var zoneTaskDict = MapOL.newCustDictionary(currentZonetaskorcombined, null, null);
              barrieredZoneTaskArr.push(zoneTaskDict);
              var currentSWL = currentCalcResultNSR.highestswl;
              var currentHorDistance = currentCalcResultNSR.distance;
              horizontalDistance = currentCalcResultNSR.distance;

              var currentFloor = 1;
              var currentHeight = currentFloor * heightPerFloor;
              while (currentHeight <= currentlBuildingHeight) {
                var verticalDistance = currentHeight;
                var slantDistance = Math.pow(Math.pow(currentHorDistance, 2) + Math.pow(verticalDistance, 2), 0.5);
                var hemisphericalPropagation = -1 * (20 * Math.log10(slantDistance) + 8);
                var facadeCorrection = 3;
                var totalCNLMitigated = currentSWL + hemisphericalPropagation + facadeCorrection;

                var barrierCNLPerFloor = MapOL.newCustDictionary(currentZonetaskorcombined, currentFloor, totalCNLMitigated);
                cnlPerFloor.push(barrierCNLPerFloor);

                currentFloor = currentFloor + 1;
                currentHeight = currentFloor * heightPerFloor;
              }
            } else {
              var currentCNL = currentCalcResultNSR.cnl;
              var nonBarrierFixedCNL = MapOL.newCustDictionary(currentZonetaskorcombined, null, currentCNL);
              nonBarrierCNL.push(nonBarrierFixedCNL);
            }
          }
        }
      }

      //check floor by floor
      var currentFloor = 1;
      var currentHeight = currentFloor * heightPerFloor;
      var greenFound = false;
      while (currentHeight <= currentlBuildingHeight) {
        var thisFloorCNLs = [];

        //check the barriered activities first
        for (let i = 0; i < barrieredZoneTaskArr.length; i++) {
          var zoneTaskObj = barrieredZoneTaskArr[i];
          var currentZoneTask = zoneTaskObj.key;

          for (let j = 0; j < cnlPerFloor.length; j++) {
            var cnlPerFloorObj = cnlPerFloor[j];
            if (cnlPerFloorObj.key === currentZoneTask && cnlPerFloorObj.item === currentFloor) {
              var thisFloorCNL = MapOL.newCustDictionary(currentZoneTask, null, cnlPerFloorObj.remark);
              thisFloorCNLs.push(thisFloorCNL);
            }
          }
        }

        // add the non barriered activities
        for (let i = 0; i < nonBarrierCNL.length; i++) {
          var thisFloorCNL = MapOL.newCustDictionary(nonBarrierCNL[i].key, null, nonBarrierCNL[i].remark);
          thisFloorCNLs.push(thisFloorCNL);
        }

        // add the combination
        var cnlsToCombine = [];
        for (let i = 0; i < combinedZoneTaskArr.length; i++) {
          var currentCombination = combinedZoneTaskArr[i];
          var combinations = currentCombination.key.split("+");

          for (let j = 0; j < combinations.length; j++) {
            var currentZoneTask = combinations[j];

            for (let k = 0; k < thisFloorCNLs.length; k++) {
              var thisFloorObj = thisFloorCNLs[k];
              if (thisFloorObj.key === currentZoneTask) {
                var theCNL = thisFloorObj.remark;
                cnlsToCombine.push(theCNL);
                break;
              }
            }
          }

          var thisCombinedCNL = MapOL.getCombinedNoiseLevelOL(cnlsToCombine);
          var thisFloorCNL = MapOL.newCustDictionary(currentCombination, null, thisCombinedCNL);
          thisFloorCNLs.push(thisFloorCNL);
        }

        // get the max CNL
        var maxCNL = 0;
        for (let i = 0; i < thisFloorCNLs.length; i++) {
          var aThisFloorCNL = thisFloorCNLs[i];
          var aCNL = aThisFloorCNL.remark;
          if (maxCNL < aCNL) {
            maxCNL = aCNL;
          }
        }

        //compare this floor's cnl with currentNoiseCriteria
        if (maxCNL <= currentNoiseCriteria) {
          greenFound = true;
          break;
        }

        currentFloor = currentFloor + 1;
        currentHeight = currentFloor * heightPerFloor;
      }
      if (!greenFound) {
        currentFloor = currentlBuildingTotalFloor;
        currentHeight = currentFloor * heightPerFloor;
      }

      //calculate barrier height
      var barrierDistFromEqp = 3; // barrier located fixed distance from equipment
      var defaultEquipmentBaseHeight = 1; // 1 meter from ground;
      var maxHeight = 7; // max barrier height = 7 meter
      var barHeight = (currentHeight * barrierDistFromEqp) / horizontalDistance + defaultEquipmentBaseHeight;
      // if(barHeight > maxHeight) {
      //     barHeight = maxHeight;
      // }
      console.log("currentHeight", currentHeight);
      console.log("BuildingHeight", currentlBuildingHeight);
      console.log("horizontalDistance", horizontalDistance);
      console.log("barrierDistFromEqp", barrierDistFromEqp);

      //save back to vars
      if (greenFound) {
        this.lastRedFloor = currentFloor - 1;
      } else {
        this.lastRedFloor = currentFloor;
      }
      this.barrierHeight = barHeight;
      this.totalFloor = currentlBuildingTotalFloor;
    },
    rankChange() {
      this.setCurrentRankParameters(this.selectedRank);
    },
    getTaskFromStartAndEndDate(startDateString, endDateString, zoneId) {
      if (startDateString.toString().includes("T")) {
        startDateString = startDateString.toString().split("T")[0];
      }
      if (endDateString.toString().includes("T")) {
        endDateString = endDateString.toString().split("T")[0];
      }
      var taskObjArr = this.project.tasks;
      var found = false;
      for (let i = 0; i < taskObjArr.length; i++) {
        if (startDateString === taskObjArr[i].start && endDateString === taskObjArr[i].end && zoneId === taskObjArr[i].zone) {
          found = true;
          return taskObjArr[i].name;
        }
      }
      if (found === false) {
        console.log("Cannot found task name");
      }
      return "";
    },
    getTaskFromTaskId(taskId) {
      var taskObjArr = this.project.tasks;
      var found = false;
      for (let i = 0; i < taskObjArr.length; i++) {
        if (taskId === taskObjArr[i].id) {
          found = true;
          return taskObjArr[i].name;
        }
      }
      if (found === false) {
        console.log("Cannot found task name");
      }
      return "";
    },
    dynamicSort(property) {
      var sortOrder = 1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a, b) {
        /* next line works with strings and numbers,
         * and you may want to customize it to your needs
         */
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;

        //this line below only works with numbers
        if (property.includes("-")) {
          //this is for ordering according to the result of 2 columns subtraction
          var properties = property.split("-");
          var propA = properties[0];
          var propB = properties[1];
          result = a[propA] - a[propB] < b[propA] - b[propB] ? -1 : a[propA] - a[propB] > b[propA] - b[propB] ? 1 : 0;
        }
        return result * sortOrder;
      };
    },
    dynamicSortMultiple(args) {
      /*
       * save the arguments object as it will be overwritten
       * note that arguments object is an array-like object
       * consisting of the names of the properties to sort by
       */
      console.log("Enter dynamicSortMultiple");
      let prop = this;
      var props = args;
      return function (obj1, obj2) {
        var i = 0,
          result = 0,
          numberOfProperties = props.length;
        /* try getting a different result from 0 (equal)
         * as long as we have extra properties to compare
         */
        while (result === 0 && i < numberOfProperties) {
          result = prop.dynamicSort(props[i])(obj1, obj2);
          i++;
        }
        return result;
      };
    },
    copyMitigationForEquipment(rowData) {
      var currentPME = rowData.pme;
      var currentQPMEName = rowData.qpmename;
      var currentQPMENoisePower = rowData.qpmeNoisePower;
      var currentEnclosureDBA = rowData.enclosureDba;
      var currentBarrierDBA = rowData.barrierDba;
      var currentHammerDBA = rowData.hammerDba;
      var currentcustommethoddba = rowData.custommethoddba;
      var currentcustommethodname = rowData.custommethodname;
      var currentIsQCM = rowData.isQCM;

      for (let i = 0; i < this.updatedMitigatedEquipmentsAll.length; i++) {
        var anObj = this.updatedMitigatedEquipmentsAll[i];
        if (anObj.pme === currentPME) {
          anObj.qpmename = currentQPMEName;
          anObj.qpmeNoisePower = currentQPMENoisePower;
          anObj.enclosureDba = currentEnclosureDBA;
          anObj.barrierDba = currentBarrierDBA;
          anObj.hammerDba = currentHammerDBA;
          anObj.custommethoddba = currentcustommethoddba;
          anObj.custommethodname = currentcustommethodname;
          anObj.isQCM = currentIsQCM;
        }
      }
    },
    getIsCustomMethod(name) {
      return !this.qcmEquipmentList.includes(name) && name != "";
    },
  },

  mounted() {
    this.stage = this.$route.params.page ? Number(this.$route.params.page) : 1;
    let props = this;
    MapOL.getProjectPMEFeatures(function (projectPMEFeatures, centroidDict) {
      props.fixedLocationFeatures = projectPMEFeatures;
      props.zoneCentroidDictionary = centroidDict;
      props.axios
        .get(`${props.apiEndpoint}cwactpme?type=qcm`)
        .then(function (response) {
          props.qcmList = response.data;
          props.qcmList.push({ name: "Custom", equipments: [{ name: "Custom" }] });
          props.qcmEquipmentList = response.data
            .map((r) => r.equipments)
            .flat()
            .map((e) => e.name);
          console.log(props.qcmEquipmentList);
        })
        .catch((error) => {
          console.log(error);
        });
    });
    this.initMitigatedEquipments();
    this.currentGroupResultUnmitigated = MapOL.getCalculationResult();
  },
};
</script>

<style></style>
<style scoped>
.card {
  height: 85vh;
  width: 95vw;
  position: absolute;
  transform: translate(4%, 2%);
}

.scrollContentPanel {
  width: 100%;
  height: calc(85vh - 3.5rem - 130px);
  text-align: left;
}
</style>
